import ToolbarTable from './toolbar-table';

export default ToolbarTable;
